"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WeekDayLabel = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_konva_1 = require("react-konva");
var react_1 = __importStar(require("react"));
var luxon_1 = require("luxon");
var FONT_SIZE = 12;
var WeekDayLabel = function (_a) {
    var _b;
    var x = _a.x, y = _a.y, font = _a.font, todayFillColor = _a.todayFillColor, labelColor = _a.labelColor, dateString = _a.date, today = _a.today, additionalText = _a.additionalText, width = _a.width, limited = _a.limited;
    var _c = (0, react_1.useState)({ width: 0, height: 0 }), dateSize = _c[0], setDateSize = _c[1];
    var dateText = (0, react_1.useRef)(null);
    var date = luxon_1.DateTime.fromISO(dateString, { zone: "utc" }).startOf("day");
    var printableDate = date.toFormat("d");
    if (parseInt(printableDate) === 1) {
        printableDate = date.toFormat("MMM d");
    }
    (0, react_1.useEffect)(function () {
        var _a, _b, _c, _d;
        var width = (_b = (_a = dateText.current) === null || _a === void 0 ? void 0 : _a.textWidth) !== null && _b !== void 0 ? _b : 0;
        var height = (_d = (_c = dateText.current) === null || _c === void 0 ? void 0 : _c.textHeight) !== null && _d !== void 0 ? _d : 0;
        if ((dateSize.width !== width, dateSize.height !== height)) {
            setDateSize({
                width: width,
                height: height,
            });
        }
    }, [dateSize, setDateSize, dateText]);
    var rectWidth = dateSize.width + 12;
    var labelX = today ? x + 6 : x;
    var labelY = y + 3;
    var textSize = today ? rectWidth : (_b = dateSize.width) !== null && _b !== void 0 ? _b : 0;
    var additionalTextX = x + textSize + 6;
    return ((0, jsx_runtime_1.jsxs)(react_1.default.Fragment, { children: [today ? ((0, jsx_runtime_1.jsx)(react_konva_1.Rect, { x: x, y: y, height: dateSize.height + 6, width: rectWidth, fill: todayFillColor, cornerRadius: 8 }, void 0)) : null, (0, jsx_runtime_1.jsx)(react_konva_1.Text, { ref: dateText, text: printableDate, x: labelX, y: labelY, fontSize: FONT_SIZE - (limited ? 4 : 0), fontFamily: font, align: "left", fill: today ? "#fff" : labelColor }, void 0), additionalText ? ((0, jsx_runtime_1.jsx)(react_konva_1.Text, { text: additionalText, x: additionalTextX, y: labelY, fontSize: FONT_SIZE - (limited ? 4 : 0), fontFamily: font, align: "left", fill: labelColor, width: (width !== null && width !== void 0 ? width : 100) - textSize }, void 0)) : null] }, void 0));
};
exports.WeekDayLabel = WeekDayLabel;
